export const HeaderTastic = () => (
  <div className="container-fluid logo-div">
    <div className="d-flex">
      <a href={process.env.NEXT_PUBLIC_EDX_LEARNER_DASHBOARD_URL}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          className="logo"
          src="https://edx-cdn.org/v3/prod/logo.svg"
          alt="edX logo"
        />
      </a>
    </div>
  </div>
);
